module.exports = __webpack_public_path__ + "static/media/backgroundDj.298a0cdc.m4a";